import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import PrivateRoute from './core/PrivateRoute';

import HomeComponent from './home/HomeComponent';
import AuthComponent from './auth/AuthComponent';
import CODComponent from './order/CODComponent'
import OrdersComponent from './order/OrdersComponent';
import OrderDetailComponent from './order/OrderDetailComponent';
import StoreImageComponent from './order/StoreImageComponent';
import OrderProductsComponent from './order/OrderProductsComponent';
import VerifyOrderComponent from './order/VerifyOrderComponent';
import AssetTracking from './order/AssetTracking/AssetTracking';
import SummaryPage from './order/SummaryPage/SummaryPage';
import { faBars, faMinus, faCamera, faImages, faBell, faSpinner, faCompass, faPlus, faEdit, faUser, faTag, faPhone, faScroll, faSearch, faTimes, faChevronCircleLeft, faChevronCircleRight, faCheck, faBan, faChevronRight, faChevronUp, faChevronDown, faChevronLeft, faTrash, faFilter, faAngleDown, faInfoCircle , faLock} from '@fortawesome/free-solid-svg-icons';
import PhoneListComponent from "./order/PhoneListComponent";
import VerifyDeliveryComponent from "./order/VerifyDeliveryComponent";
import InvoiceComponent from "./order/InvoiceComponent";
import SuccessComponent from "./core/SuccesComponent";
import DeliverySuccessComponent from "./order/DeliverySuccessComponent";
import ReasonList from "./reasonList";
import ReasonListPhotoView from "./reasonList/ReasonListPhotoView";
import DefaultComponent from './auth/DefaultComponent';

library.add(faBars,
  faPlus,
  faMinus,
  faEdit,
  faCompass,
  faUser,
  faTag,
  faSearch,
  faPhone,
  faScroll,
  faTimes,
  faChevronCircleLeft,
  faChevronCircleRight,
  faCheck,
  faBan,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faTrash,
  faBell,
  faFilter,
  faCamera,
  faImages,
  faAngleDown,
  faLock,
  faInfoCircle,
  faSpinner);

class AppComponent extends Component {

  state = {
    offline: !navigator.onLine
  }

  setOfflineStatus = () => {
    this.setState({ offline: !navigator.onLine });
  }

  componentDidMount = () => {
    window.addEventListener('online', this.setOfflineStatus)
    window.addEventListener('offline', this.setOfflineStatus)
  }

  componentWillUnmount = () => {
    window.removeEventListener('online', this.setOfflineStatus)
    window.removeEventListener('offline', this.setOfflineStatus)
  }

  render() {
    return (
      <div className = "mb-120">
        {
          this.state.offline && <div className="offline-msg fs-14">Please connect to internet!</div>
        }
        <Switch>
          <PrivateRoute exact path="/orders" render={() => <OrdersComponent />} />
          <PrivateRoute exact path="/order/:id" render={() => <OrderDetailComponent />} />
          <PrivateRoute exact path="/order/:id/storeImage" render={() => <StoreImageComponent />} />
          <PrivateRoute exact path="/order/:id/products" render={() => <OrderProductsComponent />} />
          <PrivateRoute exact path="/order/:id/assetTrack" render={() => <AssetTracking />} />
          <PrivateRoute exact path="/order/:id/verify" render={() => <VerifyOrderComponent />} />
          <PrivateRoute exact path="/order/:id/invoice" render={() => <InvoiceComponent />} />
          <PrivateRoute exact path="/order/:id/summary" render={() => <SummaryPage />} />
          <PrivateRoute exact path="/order/:id/verifyDelivery" render={() => <VerifyDeliveryComponent />}/>
          <PrivateRoute exact path="/order/:id/cod" render={()=> <CODComponent />}/>
          <PrivateRoute exact path="/order/:orderId/reason/:reasonId/:reasonType" render={()=> <ReasonList />}/>
          <PrivateRoute exact path="/order/:orderId/reason/:reasonId/:reasonType/photo" render={()=> <ReasonListPhotoView />}/>
          <PrivateRoute exact path="/success" render={()=><DeliverySuccessComponent />}/>
          <PrivateRoute reverse={true} path="/" render={() => <DefaultComponent />} />
          {/* <PrivateRoute reverse={true} path="/" render={() => <AuthComponent />} /> */}
        </Switch>
      </div>
    )
  }

}

export default AppComponent;
